import React, { forwardRef } from 'react';
import classNames from 'classnames';

import './_filter-row.scss'
import './_filter-row.dark-mode.scss'

import PropTypes from 'prop-types';

import { UI_NAME } from '../../../utils/config';

const FilterRow = forwardRef(
  (props, ref) => {
    const { isActive, showCheckbox, disabled, onClick } = props;

    const onClickCheckBox = (e) => {
      e.stopPropagation();
      onClick(e)
    }

    return (
      <div
        onClick={onClick}
        className={classNames(`${UI_NAME}-filter-row`, {
          [`${UI_NAME}-filter-row--disabled`]: disabled,
          ...props.className,
        })}
        ref={ref}
      >
        {showCheckbox
          ? (
            <div className={`${UI_NAME}-filter-row__checkbox`}>
              <input
                checked={isActive}
                type="checkbox"
                onChange={() => {}}
                onClick={onClickCheckBox}
              />
            </div>
          ) : null}
        <div className={`${UI_NAME}-filter-row__content`}>
          {props.children}
        </div>
      </div>
    )
  },
)

FilterRow.defaultProps = {
  disabled: false,
  isActive: false,
  showCheckbox: false,
}

FilterRow.propTypes = {
  isActive: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
}

export default FilterRow
